import { Component, Input } from '@angular/core';

@Component({
  selector: 'tr-static-text',
  templateUrl: './static-text.component.html',
  //styleUrls: ['./static-text.component.scss']
})
export class StaticTextComponent {
  @Input() text: string;
}



// WEBPACK FOOTER //
// ./src/app/authentication/components/static-text/static-text.component.ts